var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-49"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 333.04,
    r: 19.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.16,321.37a4.45,4.45,0,0,1-.73,2.67,5.36,5.36,0,0,1-2.14,1.89,3.87,3.87,0,0,1-2.89.24,4,4,0,0,1-2.2-1.69,5.83,5.83,0,0,0,2.36,1,3.28,3.28,0,0,0,1.21,0,3.55,3.55,0,0,0,1.14-.37c.19-.09.37-.19.55-.29s.36-.23.52-.36a6.15,6.15,0,0,0,.91-.86A6.81,6.81,0,0,0,275.16,321.37Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08,322.5a2.86,2.86,0,0,1,.41-1.88,3.63,3.63,0,0,1,1.48-1.35,2.73,2.73,0,0,1,2.06-.15,2.63,2.63,0,0,1,1.47,1.26,4.48,4.48,0,0,0-1.63-.61,2.74,2.74,0,0,0-1.52.27A4.7,4.7,0,0,0,268.08,322.5Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,342.28a2.7,2.7,0,0,1,.05,1.88,3.36,3.36,0,0,1-1.14,1.59,2.57,2.57,0,0,1-1.94.52,2.61,2.61,0,0,1-1.65-.9,4.63,4.63,0,0,0,1.68.23,2.56,2.56,0,0,0,1.39-.53,3.93,3.93,0,0,0,1-1.18A4.87,4.87,0,0,0,268,342.28Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.92,344.52a1.72,1.72,0,0,1-.13-1.32,2.2,2.2,0,0,1,.79-1.15,1.8,1.8,0,0,1,1.41-.36,1.7,1.7,0,0,1,1.11.73,3.82,3.82,0,0,0-1.15-.05,1.71,1.71,0,0,0-.85.36A3.39,3.39,0,0,0,263.92,344.52Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.91,324.59a1.76,1.76,0,0,1,.56,1.26,1.94,1.94,0,0,1-.56,1.39,1.69,1.69,0,0,1-1.44.49,2,2,0,0,1-1.24-.59,6.63,6.63,0,0,0,1.23-.08,1.56,1.56,0,0,0,.84-.42,2,2,0,0,0,.5-.86A3.68,3.68,0,0,0,260.91,324.59Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.47,326.5a1.13,1.13,0,0,1-.49-.87,1.34,1.34,0,0,1,.39-1,1.2,1.2,0,0,1,1.07-.34,1.26,1.26,0,0,1,.85.51,5.84,5.84,0,0,0-.83.16,1,1,0,0,0-.48.28,1.41,1.41,0,0,0-.33.5A2.88,2.88,0,0,0,258.47,326.5Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.58,345.32a1.74,1.74,0,0,1-1.09.85A1.89,1.89,0,0,1,272,346a1.72,1.72,0,0,1-.84-1.27,2.09,2.09,0,0,1,.28-1.35,5.54,5.54,0,0,0,.38,1.17,1.44,1.44,0,0,0,.61.71,1.92,1.92,0,0,0,.95.28A3.58,3.58,0,0,0,274.58,345.32Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.13,343.43a1.12,1.12,0,0,1,.72-.69,1.34,1.34,0,0,1,1.1.12,1.23,1.23,0,0,1,.6,1,1.28,1.28,0,0,1-.29.95,8.39,8.39,0,0,0-.36-.77,1.07,1.07,0,0,0-.39-.4,1.76,1.76,0,0,0-.56-.2A2.94,2.94,0,0,0,272.13,343.43Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.32,331.48a1.82,1.82,0,0,1-.42,1.32,2,2,0,0,1-1.34.67,1.75,1.75,0,0,1-1.41-.59,2.08,2.08,0,0,1-.53-1.27,6.06,6.06,0,0,0,1,.75,1.54,1.54,0,0,0,.91.25,2,2,0,0,0,.94-.31A3.7,3.7,0,0,0,281.32,331.48Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.23,331.29a1.1,1.1,0,0,1,.21-1,1.32,1.32,0,0,1,1-.51,1.21,1.21,0,0,1,1,.46,1.25,1.25,0,0,1,.29.94,5.05,5.05,0,0,0-.73-.43,1,1,0,0,0-.54-.11,1.47,1.47,0,0,0-.58.15A3.26,3.26,0,0,0,278.23,331.29Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.26,335.94a1.76,1.76,0,0,1-.42,1.31,1.91,1.91,0,0,1-1.34.67,1.72,1.72,0,0,1-1.41-.59,2.09,2.09,0,0,1-.53-1.26,6.54,6.54,0,0,0,1,.75,1.52,1.52,0,0,0,.91.24,2,2,0,0,0,.94-.3A3.7,3.7,0,0,0,255.26,335.94Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.17,335.74a1.12,1.12,0,0,1,.21-1,1.36,1.36,0,0,1,1-.51,1.22,1.22,0,0,1,1,.45,1.27,1.27,0,0,1,.29.94,6,6,0,0,0-.73-.42,1,1,0,0,0-.54-.12,1.56,1.56,0,0,0-.57.15A3,3,0,0,0,252.17,335.74Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.42,259.92a58.3,58.3,0,0,0,4.27,22.15C55.58,289,60.15,295.14,66.07,299a29.22,29.22,0,0,0,4.56,2.47,26.69,26.69,0,0,0,4.84,1.48,26.07,26.07,0,0,0,9.8.14c6.44-1.11,12.38-4.3,17.64-8.5.32-.27.68-.54,1-.79l.74-.71c.48-.5,1-1,1.42-1.53a27.82,27.82,0,0,0,2.61-3.49,52.05,52.05,0,0,0,4.35-8.39,145.33,145.33,0,0,0,6.37-19.83c3.57-14,6.41-28.83,9.79-43.89q1.26-5.66,2.69-11.36c.92-3.81,1.94-7.63,3-11.48a161.64,161.64,0,0,1,8.28-23.42c.92-2,1.93-4,3.13-6.07.59-1,1.26-2.07,2-3.09s1.46-2,2.25-2.89a49.56,49.56,0,0,1,10.41-9.14c7.34-4.93,14.88-8,22.12-11.12s14.38-6,21.13-9.45a99.42,99.42,0,0,0,18.73-12.21A65.22,65.22,0,0,0,237,99.24c3.68-6.19,6.36-12.94,7.13-19.51A32.17,32.17,0,0,0,244,70.3a21.87,21.87,0,0,0-3-7.86,18.26,18.26,0,0,0-12.08-8.19,25,25,0,0,0-7.65-.3,33.94,33.94,0,0,0-8,2c-.67.25-1.33.53-2,.81l-2.36,1c-1.56.7-3.11,1.43-4.62,2.21-3,1.55-6,3.22-8.91,5.09-5.83,3.69-11.56,8.16-17.94,13a172.32,172.32,0,0,1-21.12,13.91A136.18,136.18,0,0,1,132.25,102c-1,.34-2.06.61-3.09.91l-2.77.79c-1.53.45-3.08.94-4.62,1.47-3.07,1.08-6.11,2.31-9.07,3.68-11.83,5.52-22.17,13.26-29.53,23.32a76.34,76.34,0,0,0-9.37,16.63,78.17,78.17,0,0,0-3.29,9.5,98.71,98.71,0,0,0-2.34,10.18c-.6,3.49-1.07,7.07-1.36,10.71-.15,1.71-.26,3.94-.4,6s-.35,4.11-.59,6.15a173.78,173.78,0,0,1-4.55,23.91c-2,7.77-4.48,15.29-7,22.68-1.27,3.7-2.54,7.37-3.67,11A41.77,41.77,0,0,0,48.42,259.92Zm-3,0a31.83,31.83,0,0,1,.62-6.09c.35-2,.81-3.89,1.26-5.79.9-3.81,1.87-7.57,2.67-11.35s1.51-7.55,2-11.34.81-7.59,1-11.38a112.57,112.57,0,0,0-1.44-22.45c-.28-1.84-.64-3.66-1-5.47s-.79-3.49-1.21-5.64a114.41,114.41,0,0,1-1.87-12.54,92.24,92.24,0,0,1,1.21-26.22,80.71,80.71,0,0,1,9.72-25.61A89.58,89.58,0,0,1,76.15,94.84a101.23,101.23,0,0,1,22.67-15,105.35,105.35,0,0,1,12.44-5.14c2.12-.75,4.28-1.4,6.48-2l5.34-1.43a120.07,120.07,0,0,0,19.11-7,152.54,152.54,0,0,0,18.47-10.45c6.35-4,13.22-8.67,20.84-12.72a123,123,0,0,1,11.77-5.55c2-.83,4-1.58,6.1-2.3l3.08-1c1.17-.35,2.35-.69,3.54-1a53.28,53.28,0,0,1,14.94-1.61,44.9,44.9,0,0,1,15.23,3.18,39.64,39.64,0,0,1,13.23,8.74,37,37,0,0,1,8.48,13.13,39.87,39.87,0,0,1,2.53,14.59,47.75,47.75,0,0,1-2.16,13.67,74.06,74.06,0,0,1-12.05,22.58,91.46,91.46,0,0,1-8.19,9.36,105.33,105.33,0,0,1-9.25,8.1c-12.89,10-27.53,16.64-40.76,24.37-6.6,3.82-12.89,8-17.66,12.82a33,33,0,0,0-5.64,7.6q-.51,1-.93,2c-.27.65-.52,1.31-.77,2-.49,1.44-.94,3-1.35,4.66-.81,3.29-1.44,6.84-2,10.46s-1.06,7.33-1.57,11.07l-1.48,11.34c-.5,3.81-1,7.65-1.6,11.51-2.36,15.4-5.36,31.11-11,46.75a109.05,109.05,0,0,1-11.3,23.13c-1.27,1.86-2.59,3.7-4.06,5.5a51.73,51.73,0,0,1-4.78,5.21,47.17,47.17,0,0,1-5.66,4.67,34.88,34.88,0,0,1-3.18,2l-1.68.9c-.54.28-1,.48-1.53.72A62.24,62.24,0,0,1,99.12,314a47.38,47.38,0,0,1-13.55,1,39.13,39.13,0,0,1-13.08-3.26,36.15,36.15,0,0,1-5.78-3.23,39.19,39.19,0,0,1-5-4.06,50.21,50.21,0,0,1-12.61-21A81.2,81.2,0,0,1,45.42,260Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.32,293.37a101.21,101.21,0,0,0,9.15-25c2.09-8.67,3.42-17.52,4.72-26.47.69-4.47,1.31-9,2.13-13.53a122.34,122.34,0,0,1,3.1-13.81,61.27,61.27,0,0,1,5.9-14A38.67,38.67,0,0,1,211.12,188c1.29-.85,2.68-1.56,4-2.32s2.86-1.24,4.32-1.81,3-.9,4.46-1.28,3-.55,4.49-.8a59.67,59.67,0,0,1,17.29.23A69.54,69.54,0,0,1,262,186.72a96.59,96.59,0,0,1,14.09,7.53,201.54,201.54,0,0,1,23.14,17.87l10.24,9c1.67,1.47,3.36,2.87,5,4.28l2.49,2.09,2.49,2a123.35,123.35,0,0,0,10.08,7.27,69.36,69.36,0,0,0,10.36,5.58A70.67,70.67,0,0,0,351.73,246c4.22,1,8.62,1.74,13.13,2.4,9,1.33,18.4,2.17,27.91,3.27l7.15.89c2.41.35,4.8.71,7.22,1.15a97.46,97.46,0,0,1,14.48,3.58,48.73,48.73,0,0,1,13.8,7.05,34.93,34.93,0,0,1,10.12,12,39.32,39.32,0,0,1,2.78,7.12l.9,3.63c.25,1.2.41,2.36.62,3.55a79.25,79.25,0,0,1,.81,14.37,74.88,74.88,0,0,1-2.12,14.34c-.32,1.17-.56,2.37-.94,3.52l-1.12,3.47c-.86,2.27-1.73,4.55-2.76,6.75a98.69,98.69,0,0,1-16.09,24.35,124.79,124.79,0,0,1-10.28,10.42c-3.58,3.33-7.4,6.36-11.28,9.31-2,1.42-3.92,2.91-5.95,4.25l-3,2.06-3.07,2q-6.19,3.88-12.64,7.3c-2.15,1.13-4.32,2.22-6.49,3.32s-4.39,2.08-6.6,3.07-4.43,2-6.68,2.89-4.48,1.84-6.76,2.67l-13,4.86c-2.12.79-4.2,1.64-6.29,2.46l-3.14,1.24-3.11,1.29A437.88,437.88,0,0,0,281.21,438c-7.81,4.41-15.55,9-23.95,13.64-4.19,2.35-8.63,4.63-13.49,6.8a89.56,89.56,0,0,1-16,5.46,70.34,70.34,0,0,1-18,1.81,81.36,81.36,0,0,1-17.07-2.35c-2.72-.59-5.25-1.38-7.82-2.13-1.27-.4-2.49-.84-3.73-1.25s-2.46-.83-3.74-1.36l-3.78-1.52-1.88-.78-1.87-.91a73.77,73.77,0,0,1-7.37-3.94c-1.2-.74-2.4-1.46-3.59-2.23l-3.46-2.55-1.7-1.29c-.57-.44-1.09-.95-1.64-1.43l-3.2-2.92c-1-1-2-2.16-2.94-3.23l-1.44-1.64c-.46-.56-.87-1.16-1.31-1.75-.85-1.18-1.71-2.35-2.53-3.54s-1.45-2.5-2.15-3.76A55.43,55.43,0,0,1,133,411.39l-.41-2c-.11-.67-.18-1.33-.26-2-.16-1.32-.33-2.64-.44-4a77.21,77.21,0,0,1-.05-7.75,87.7,87.7,0,0,1,1.94-14.78,127.26,127.26,0,0,1,3.92-13.82,224.1,224.1,0,0,1,10.87-25.67c1-2.05,2-4.13,3.08-6.15s2-4.08,3.13-6.09,2.14-4,3.22-6l3.23-6Zm2.66,1.36c-4.28,7.92-8.26,16-11.8,24.25l-1.32,3.09-1.24,3.12c-.85,2.07-1.6,4.18-2.36,6.28-1.55,4.19-2.89,8.45-4.13,12.72A145.2,145.2,0,0,0,151.05,370a107.36,107.36,0,0,0-.57,12.73,75.5,75.5,0,0,0,1.25,12.12c.27,2,.88,3.81,1.32,5.67l.91,2.67c.16.44.29.88.45,1.31l.57,1.26a37.66,37.66,0,0,0,5.35,9c.55.66,1.1,1.3,1.61,2l1.8,1.8c.3.3.58.62.89.9l1,.81c.67.53,1.29,1.1,2,1.62l2.15,1.48c.36.25.69.52,1.07.74l1.17.67,2.31,1.35,2.49,1.19a78,78,0,0,0,10.67,4.13c.9.32,1.91.59,2.91.86s2,.57,3,.81c1.95.43,3.91.95,5.79,1.24a53.75,53.75,0,0,0,10.76,1,41.87,41.87,0,0,0,9.78-1.31c6.47-1.65,13.69-5.17,21.52-9.36,3.91-2.07,7.9-4.27,12-6.5s8.29-4.4,12.5-6.58a407.34,407.34,0,0,1,52.91-22.43L322,388l3.41-1.12c2.27-.74,4.54-1.51,6.82-2.21l13.35-4.07c4.25-1.31,8.46-2.7,12.65-4.13l6.23-2.25c2.06-.79,4.12-1.57,6.17-2.38,4.05-1.68,8.14-3.33,12.08-5.21l3-1.38,2.93-1.45c2-.94,3.85-2,5.78-3a133.05,133.05,0,0,0,21.36-14.42,90.55,90.55,0,0,0,9.11-8.83,66.14,66.14,0,0,0,7.51-10,56.49,56.49,0,0,0,8.19-23.31,57.7,57.7,0,0,0-.06-12.53c-.15-1-.25-2.1-.43-3.12l-.62-3a31.43,31.43,0,0,0-2.08-5.54,23.68,23.68,0,0,0-7.48-8.83,35,35,0,0,0-11.2-5.13,74.51,74.51,0,0,0-13-2.2c-4.46-.37-9-.5-13.6-.46-9.18.05-18.54.62-28.19.82-4.84.07-9.76,0-14.82-.3a92.3,92.3,0,0,1-15.59-2.22c-10.91-2.67-20.31-7.56-28.82-13-16.9-10.94-30.21-24-43.73-33.61-6.73-4.79-13.39-8.61-20.25-10.71a42.89,42.89,0,0,0-10.62-1.84,21,21,0,0,0-17.58,7,46.9,46.9,0,0,0-6.93,9.76A113,113,0,0,0,200.12,231c-1.61,4.11-3.14,8.32-4.53,12.58-2.86,8.52-5.37,17.23-8.24,25.84A159.82,159.82,0,0,1,177,294.73Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.72,89.88a64.88,64.88,0,0,1-4.31,7.79c-.74,1.2-1.52,2.33-2.3,3.47s-1.6,2.21-2.42,3.26c-1.62,2.14-3.32,4.11-5,6.08-6.86,7.75-14.33,14.4-21.65,21l-2.59,2.35-1.14,1L412.2,136c-.75.75-1.41,1.61-2.11,2.43s-1.32,1.76-2,2.68-1.26,1.86-1.84,2.86-1.17,2-1.72,3c-1.07,2-2.16,4.17-3.11,6.35-4,8.74-7,18.13-11.61,27.54a52.37,52.37,0,0,1-9.47,13.6,38.78,38.78,0,0,1-7,5.56,41.88,41.88,0,0,1-4,2.16c-.69.32-1.38.66-2.08.94l-2.12.79a51.81,51.81,0,0,1-8.66,2.18c-1.48.27-3.08.35-4.65.49s-3.1,0-4.67,0-3-.27-4.59-.44a22.54,22.54,0,0,1-2.23-.38l-2.22-.45-1.11-.24-1.07-.31-2.14-.64a36.59,36.59,0,0,1-4.16-1.47,67.81,67.81,0,0,1-14.93-8.28,82.24,82.24,0,0,1-12.23-11.14A80.54,80.54,0,0,1,293,170c-.67-1.18-1.31-2.37-1.94-3.55s-1.16-2.45-1.73-3.67-1.09-2.46-1.57-3.72-1-2.49-1.4-3.79a99.46,99.46,0,0,1-3.92-15.55,98.36,98.36,0,0,1-1.44-15.7,81.48,81.48,0,0,1,1.16-15.35,51.89,51.89,0,0,1,4.72-14.4,34,34,0,0,1,10-11.68,57.4,57.4,0,0,1,13.84-7.29,153.06,153.06,0,0,1,30.35-7.58c5.11-.78,10.19-1.3,15.22-1.62a8.57,8.57,0,0,0,1.45-.19l1.17-.21c.8-.24,1.56-.31,2.35-.59l1.16-.33c.39-.14.78-.3,1.17-.41.78-.21,1.6-.62,2.39-.87a94.23,94.23,0,0,0,10.52-5.07l5.93-3.33,3.17-1.79L389,51.52c2.26-1.24,4.79-2.43,7.39-3.61a72.53,72.53,0,0,1,8.68-3.15A49.61,49.61,0,0,1,415.3,42.9a41.65,41.65,0,0,1,11.31.68l1.42.27,1.38.37c.91.26,1.84.51,2.75.8a45,45,0,0,1,5.11,2.16l2.41,1.25,2.21,1.37a48.3,48.3,0,0,1,4.13,3c.35.26.62.46,1,.79s1,.88,1.51,1.34A23.56,23.56,0,0,1,451.38,58c.21.27.44.55.65.84l.61.93c.39.63.76,1.25,1.13,1.89a29.07,29.07,0,0,1,1.69,4c.2.68.38,1.35.55,2,.09.34.17.69.23,1l.16,1c.09.64.16,1.29.23,1.94s.05,1.21.07,1.82,0,1.21,0,1.79l-.14,1.64c-.06.53-.1,1.11-.19,1.61L456.08,80A45,45,0,0,1,452.72,89.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.88,354.35a43.33,43.33,0,0,1,.61,8.66,60.92,60.92,0,0,1-2.7,15.58A100.33,100.33,0,0,1,115.6,393a64,64,0,0,1-8,13.14,60.36,60.36,0,0,1-11.52,11.13,38,38,0,0,1-16.25,6.47,36.63,36.63,0,0,1-9.36.19,29.82,29.82,0,0,1-8.72-2.35,30.42,30.42,0,0,1-6.84-4.24,60.1,60.1,0,0,1-5.29-5,20.8,20.8,0,0,1-2.31-3,23.74,23.74,0,0,1-1.63-3.5,38.9,38.9,0,0,1-1.74-7.69,65.64,65.64,0,0,1-.18-16.4,37.05,37.05,0,0,1,5-14.81A37.5,37.5,0,0,1,58.9,356a64.76,64.76,0,0,1,13.5-7c4.74-1.88,9.33-3.65,13.69-5.71s8.58-4.35,13.89-6a23.81,23.81,0,0,1,4.35-.94,17.43,17.43,0,0,1,5.18.08,13.49,13.49,0,0,1,6.22,3,16.32,16.32,0,0,1,1.26,1.23c.37.42.74.85,1.09,1.3a21,21,0,0,1,1.65,2.62,24.67,24.67,0,0,1,1.2,2.58c.3.8.64,1.68.85,2.45l.35,1.21.29,1.17C122.61,352.84,122.74,353.58,122.88,354.35Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.35,186.48c23.51-18.26,47.16-14.71,47.16-14.71s.11,23.92-21.35,44.55c-18.11,17.41-35.3,16.42-41.23,9.58S385.51,201.88,405.35,186.48Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.74,198.29c14.9-11.58,29.89-9.32,29.89-9.32s.07,15.15-13.53,28.24c-11.48,11-22.39,10.41-26.14,6.07S390.16,208.05,402.74,198.29Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M413.53,204.54l-1.78-1.42a1.18,1.18,0,0,1-.19-1.66h0a1.18,1.18,0,0,1,1.66-.18L415,202.7a1.17,1.17,0,0,1,.18,1.65h0A1.17,1.17,0,0,1,413.53,204.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.46,222.85l-1.24-1.91a1.18,1.18,0,0,1,.34-1.63h0a1.18,1.18,0,0,1,1.64.34l1.24,1.91a1.18,1.18,0,0,1-.35,1.63h0A1.18,1.18,0,0,1,393.46,222.85Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.18,200.91l-1.23,0a1.18,1.18,0,0,1-1.14-1.22h0a1.18,1.18,0,0,1,1.22-1.14l1.22,0a1.17,1.17,0,0,1,1.14,1.21h0A1.18,1.18,0,0,1,405.18,200.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.5,215.7l0-1.22a1.17,1.17,0,0,1,1.21-1.14h0a1.18,1.18,0,0,1,1.15,1.21l0,1.23a1.17,1.17,0,0,1-1.21,1.14h0A1.18,1.18,0,0,1,416.5,215.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.43,216.06l-.14-1.21a1.19,1.19,0,0,1,1-1.31h0a1.19,1.19,0,0,1,1.31,1.05l.13,1.21a1.17,1.17,0,0,1-1,1.3h0A1.17,1.17,0,0,1,390.43,216.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.28,226.72l-1.14.45a1.18,1.18,0,0,1-1.53-.67h0a1.18,1.18,0,0,1,.67-1.53l1.14-.44a1.18,1.18,0,0,1,1.53.66h0A1.17,1.17,0,0,1,410.28,226.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.66,
    cy: 213.34,
    r: 13.61,
    transform: "translate(-21.16 46.18) rotate(-6.37)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.84,205.86a3,3,0,0,0,.71,1.78,3.69,3.69,0,0,0,1.61,1.14,2.69,2.69,0,0,0,2-.06,2.79,2.79,0,0,0,1.38-1.33,4.05,4.05,0,0,1-1.54.9,2.38,2.38,0,0,1-.83.09,2.59,2.59,0,0,1-.82-.16l-.4-.16c-.13-.07-.26-.13-.38-.21a4.3,4.3,0,0,1-.69-.52A4.52,4.52,0,0,1,398.84,205.86Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.79,206.1a2,2,0,0,0-.43-1.27,2.46,2.46,0,0,0-1.12-.81,1.83,1.83,0,0,0-2.34,1,3,3,0,0,1,1.08-.54,1.82,1.82,0,0,1,1.06.06A3.22,3.22,0,0,1,403.79,206.1Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.42,214.87a1.84,1.84,0,0,0,.11,1.3,2.18,2.18,0,0,0,.9,1,1.74,1.74,0,0,0,1.37.21,1.81,1.81,0,0,0,1.07-.75,3.39,3.39,0,0,1-1.14.3,1.8,1.8,0,0,1-1-.27,2.66,2.66,0,0,1-.81-.72A3.22,3.22,0,0,1,409.42,214.87Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.39,216.09a1.15,1.15,0,0,0,0-.91,1.5,1.5,0,0,0-.63-.73,1.26,1.26,0,0,0-1-.14,1.17,1.17,0,0,0-.71.59,2.65,2.65,0,0,1,.79-.13,1.29,1.29,0,0,1,.61.19A2.31,2.31,0,0,1,412.39,216.09Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.93,211.32a1.22,1.22,0,0,0-.29.91,1.32,1.32,0,0,0,.49.91,1.19,1.19,0,0,0,1,.23,1.4,1.4,0,0,0,.8-.5,5,5,0,0,1-.84,0,1,1,0,0,1-.62-.23,1.33,1.33,0,0,1-.4-.55A2.42,2.42,0,0,1,413.93,211.32Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.75,212.44a.73.73,0,0,0,.27-.63.9.9,0,0,0-.35-.68.83.83,0,0,0-.76-.16.86.86,0,0,0-.54.42,4.33,4.33,0,0,1,.58.05.76.76,0,0,1,.35.15,1.09,1.09,0,0,1,.27.32A2.17,2.17,0,0,1,415.75,212.44Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.94,209.39a1.23,1.23,0,0,0,.39.88,1.32,1.32,0,0,0,1,.35,1.18,1.18,0,0,0,.92-.51,1.44,1.44,0,0,0,.26-.91,4.71,4.71,0,0,1-.6.59,1.15,1.15,0,0,1-.61.24,1.35,1.35,0,0,1-.67-.14A2.65,2.65,0,0,1,394.94,209.39Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.05,209a.77.77,0,0,0-.22-.65.93.93,0,0,0-.71-.28.87.87,0,0,0-.8,1.06c.18-.14.32-.26.46-.35a.93.93,0,0,1,.37-.12,1,1,0,0,1,.41.07A2,2,0,0,1,397.05,209Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.56,217.73a3,3,0,1,1,1.06-4.12A3,3,0,0,1,403.56,217.73Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.47,213.88a2.73,2.73,0,0,0-1.33,2.08,3,3,0,1,1,5.38.86,2.73,2.73,0,0,0-4-2.94Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,216.1a3.93,3.93,0,0,0,.91,2.16,4.63,4.63,0,0,0,2,1.37,3.32,3.32,0,0,0,2.44,0A3.57,3.57,0,0,0,405,218a4.61,4.61,0,0,1-1.88,1.16,3.25,3.25,0,0,1-.52.12,2.35,2.35,0,0,1-.53,0,3.09,3.09,0,0,1-1-.2l-.5-.2c-.16-.09-.32-.16-.47-.26a5.11,5.11,0,0,1-.87-.66A5.7,5.7,0,0,1,398,216.1Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.81,217.6a1.12,1.12,0,0,1-.75-2.12,1.14,1.14,0,0,1,1.43.69A1.12,1.12,0,0,1,394.81,217.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,216a1,1,0,0,0-.63.67,1.11,1.11,0,0,1,.74-1.16,1.14,1.14,0,0,1,1.43.69,1.12,1.12,0,0,1-.27,1.17,1,1,0,0,0,0-.74A1,1,0,0,0,394,216Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.87,216.61a1.4,1.4,0,0,0,.15.87,1.76,1.76,0,0,0,.64.66,1.24,1.24,0,0,0,.92.15,1.27,1.27,0,0,0,.74-.49,2,2,0,0,1-.78.26,1.24,1.24,0,0,1-.73-.18A2,2,0,0,1,392.87,216.61Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.29,224a1.6,1.6,0,1,1,1.31-1.84A1.59,1.59,0,0,1,403.29,224Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.49,221.49a1.44,1.44,0,0,0-1.05.78,1.59,1.59,0,0,1,3.16-.13,1.61,1.61,0,0,1-.66,1.58,1.49,1.49,0,0,0,.22-1A1.45,1.45,0,0,0,402.49,221.49Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.83,222.11a2.1,2.1,0,0,0,.05,1.24,2.37,2.37,0,0,0,.71,1.05,1.83,1.83,0,0,0,1.21.44,1.9,1.9,0,0,0,1.16-.46,2.47,2.47,0,0,1-1.15.23,1.77,1.77,0,0,1-1-.43,2.71,2.71,0,0,1-.7-.91A2.85,2.85,0,0,1,400.83,222.11Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.65,207.86a2.71,2.71,0,1,0,.56-3.55A2.55,2.55,0,0,0,408.65,207.86Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.37,205.52a2.09,2.09,0,0,1,.34,2,2.47,2.47,0,0,0,.09-3.08,2.56,2.56,0,0,0-3.59-.12,2.73,2.73,0,0,0-1,2.6,2.62,2.62,0,0,1,.91-1.5A2.31,2.31,0,0,1,412.37,205.52Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.57,206.15a2.63,2.63,0,0,0-.13,2,2.46,2.46,0,0,0,.55.9,2.49,2.49,0,0,0,1.89.85,3.15,3.15,0,0,0,1-.14,4.2,4.2,0,0,0,1.7-1,8.76,8.76,0,0,1-1.8.53,3.16,3.16,0,0,1-1.71-.17,2.81,2.81,0,0,1-.7-.48,2.16,2.16,0,0,1-.52-.68A3.45,3.45,0,0,1,407.57,206.15Z",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Moon--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.13,340.67l7.7-7.7a5.64,5.64,0,0,0,0-8h0a5.65,5.65,0,0,0-8,0l-7.7,7.7a5.64,5.64,0,0,0,0,8h0A5.65,5.65,0,0,0,66.13,340.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.31,417l4.89-9.73a5.65,5.65,0,0,0-2.51-7.58h0a5.64,5.64,0,0,0-7.58,2.51l-4.89,9.73a5.64,5.64,0,0,0,2.51,7.58h0A5.64,5.64,0,0,0,171.31,417Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.89,318.93l5.79-.83a5.65,5.65,0,0,0,4.79-6.39h0a5.64,5.64,0,0,0-6.39-4.79l-5.79.83a5.64,5.64,0,0,0-4.79,6.39h0A5.65,5.65,0,0,0,103.89,318.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.93,395.34l-.83-5.79a5.64,5.64,0,0,0-6.39-4.79h0a5.63,5.63,0,0,0-4.78,6.38l.82,5.8a5.66,5.66,0,0,0,6.39,4.79h0A5.65,5.65,0,0,0,57.93,395.34Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.89,
    y: 374.56,
    width: 17.14,
    height: 11.29,
    rx: 2.16,
    transform: "translate(556.67 203.75) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.41,444.42l5.65,1.51a5.64,5.64,0,0,0,6.91-4h0a5.65,5.65,0,0,0-4-6.92l-5.65-1.51a5.65,5.65,0,0,0-6.92,4h0A5.67,5.67,0,0,0,93.41,444.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.97,
    cy: 377.76,
    r: 65.14,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.67,339.12a14.63,14.63,0,0,1-2.41,8.84,17.63,17.63,0,0,1-7.08,6.26,12.92,12.92,0,0,1-9.57.81,13.44,13.44,0,0,1-7.28-5.6,19.45,19.45,0,0,0,7.81,3.45,11.43,11.43,0,0,0,4,0,12.63,12.63,0,0,0,3.79-1.22c.61-.3,1.23-.63,1.83-1s1.16-.75,1.69-1.19a18.9,18.9,0,0,0,3-2.84A22.3,22.3,0,0,0,136.67,339.12Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.25,342.87a9.37,9.37,0,0,1,1.36-6.23,11.73,11.73,0,0,1,4.9-4.46,8.88,8.88,0,0,1,6.8-.49,8.65,8.65,0,0,1,4.87,4.16,14.58,14.58,0,0,0-5.4-2,8.77,8.77,0,0,0-5,.89A15.45,15.45,0,0,0,113.25,342.87Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.19,387.61a8.84,8.84,0,0,1,.16,6.21,10.81,10.81,0,0,1-3.76,5.27,8.54,8.54,0,0,1-6.41,1.73,8.72,8.72,0,0,1-5.46-3,15.72,15.72,0,0,0,5.56.78,8.4,8.4,0,0,0,4.58-1.77,13.31,13.31,0,0,0,3.46-3.89A16.18,16.18,0,0,0,91.19,387.61Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7,395a5.66,5.66,0,0,1-.44-4.36,7.25,7.25,0,0,1,2.62-3.81,5.88,5.88,0,0,1,4.65-1.18,5.6,5.6,0,0,1,3.7,2.4,12.86,12.86,0,0,0-3.8-.17,6,6,0,0,0-2.83,1.21A11.06,11.06,0,0,0,77.7,395Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.83,373.11a5.87,5.87,0,0,1,1.86,4.19,6.37,6.37,0,0,1-1.85,4.6,5.69,5.69,0,0,1-4.77,1.63,6.76,6.76,0,0,1-4.09-2A21.16,21.16,0,0,0,63,381.3a5,5,0,0,0,2.79-1.4,6.61,6.61,0,0,0,1.65-2.83A12,12,0,0,0,67.83,373.11Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.76,379.44a3.72,3.72,0,0,1-1.62-2.88,4.43,4.43,0,0,1,1.29-3.42A4.06,4.06,0,0,1,63,372a4.23,4.23,0,0,1,2.79,1.69,21.93,21.93,0,0,0-2.74.55,3.39,3.39,0,0,0-1.59.91,5.1,5.1,0,0,0-1.09,1.65A9.55,9.55,0,0,0,59.76,379.44Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.09,353.82a5.79,5.79,0,0,1-1.4,4.36,6.39,6.39,0,0,1-4.43,2.22,5.7,5.7,0,0,1-4.65-1.95,6.8,6.8,0,0,1-1.76-4.19,21.36,21.36,0,0,0,3.21,2.49,5.11,5.11,0,0,0,3,.81,6.66,6.66,0,0,0,3.11-1A12.34,12.34,0,0,0,157.09,353.82Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.85,353.19a3.72,3.72,0,0,1,.71-3.23,4.45,4.45,0,0,1,3.23-1.7,4,4,0,0,1,3.42,1.51,4.21,4.21,0,0,1,1,3.12,20,20,0,0,0-2.42-1.42,3.33,3.33,0,0,0-1.79-.37,5.07,5.07,0,0,0-1.91.5A9.7,9.7,0,0,0,146.85,353.19Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.57,398.08a14.43,14.43,0,1,0-7.24-19A14.39,14.39,0,0,0,120.57,398.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.19,378.11a13,13,0,0,1,7.42,9.19,14.37,14.37,0,1,0-25.11,7,13.09,13.09,0,0,1,17.69-16.16Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.35,387.32a18.58,18.58,0,0,1-3.18,10.76,22,22,0,0,1-8.68,7.57,15.84,15.84,0,0,1-11.6,1.06,17.05,17.05,0,0,1-9.06-6.66,22.92,22.92,0,0,0,9.59,4.5,21.72,21.72,0,0,0,2.53.27,13.9,13.9,0,0,0,2.5-.2,16,16,0,0,0,4.79-1.52c.77-.39,1.54-.8,2.28-1.24s1.46-.93,2.12-1.49a22.73,22.73,0,0,0,3.74-3.6A26.25,26.25,0,0,0,146.35,387.32Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.12,392.8a5.39,5.39,0,1,0-4-6.46A5.38,5.38,0,0,0,162.12,392.8Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.32,384.58a4.87,4.87,0,0,1,3.37,2.84,5.36,5.36,0,1,0-8.7,4.34,4.81,4.81,0,0,1-.51-3.51A4.88,4.88,0,0,1,165.32,384.58Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.79,387a6.63,6.63,0,0,1-.27,4.23,8,8,0,0,1-2.66,3.47,6,6,0,0,1-4.28,1.21,6.1,6.1,0,0,1-3.79-1.93,9.1,9.1,0,0,0,3.84.82,5.82,5.82,0,0,0,3.38-1.23A9.77,9.77,0,0,0,170.79,387Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.17,427.66a7.65,7.65,0,1,0-7.19-8.05A7.63,7.63,0,0,0,125.17,427.66Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.63,415.38a6.88,6.88,0,0,1,5.42,3.14,7.62,7.62,0,1,0-11.11,8.21,6.83,6.83,0,0,1-1.58-4.79A6.92,6.92,0,0,1,127.63,415.38Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.89,417.44a10,10,0,0,1,.43,5.92,11.67,11.67,0,0,1-2.85,5.38,8.47,8.47,0,0,1-5.52,2.72,9.15,9.15,0,0,1-5.74-1.55,12,12,0,0,0,5.6.45,8.34,8.34,0,0,0,4.62-2.59,13,13,0,0,0,2.83-4.7A13.75,13.75,0,0,0,135.89,417.44Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.09,353.87c-3.45,5.27-11.07,6.39-17,2.5s-8-11.32-4.54-16.59,11.06-6.39,17-2.5S94.53,348.6,91.09,353.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.15,344.72a10,10,0,0,0-.56,9.61c-4-4.1-5-10.09-2.06-14.56,3.44-5.26,11.06-6.38,17-2.49a13.05,13.05,0,0,1,6.18,11.79,12.43,12.43,0,0,0-5.13-6.63C82.2,338.92,75.28,339.93,72.15,344.72Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.29,345.17A12.24,12.24,0,0,1,97,354.46,11.62,11.62,0,0,1,94.85,359a14.39,14.39,0,0,1-3.73,3.43,13.85,13.85,0,0,1-4.81,1.63,16.11,16.11,0,0,1-4.91-.14,20.13,20.13,0,0,1-8.63-3.74,40.15,40.15,0,0,0,8.87,1.53,14.56,14.56,0,0,0,8-1.72,12.35,12.35,0,0,0,3.08-2.66,11.18,11.18,0,0,0,2.11-3.51A16.09,16.09,0,0,0,95.29,345.17Z",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stars--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "386.75 339.87 392.26 340.88 393.49 346.69 394.72 340.88 400.23 339.86 394.74 338.52 393.49 333.04 392.23 338.52 386.75 339.87",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.46 308.51 164.97 309.53 166.2 315.34 167.43 309.53 172.94 308.51 167.46 307.17 166.2 301.69 164.95 307.17 159.46 308.51",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.48 246.44 335.99 247.46 337.22 253.26 338.45 247.46 343.96 246.44 338.48 245.09 337.22 239.61 335.97 245.09 330.48 246.44",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.11 305.68 442.19 306.25 442.88 309.5 443.57 306.25 446.64 305.68 443.58 304.93 442.88 301.87 442.18 304.93 439.11 305.68",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.47 429.18 208.54 429.75 209.23 433 209.92 429.75 213 429.18 209.93 428.43 209.23 425.37 208.53 428.43 205.47 429.18",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431.58 159.59 434.66 160.16 435.35 163.4 436.03 160.16 439.11 159.58 436.05 158.84 435.35 155.77 434.64 158.84 431.58 159.59",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.39 229.4 71.47 229.97 72.16 233.21 72.84 229.97 75.92 229.4 72.86 228.65 72.16 225.58 71.46 228.65 68.39 229.4",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.91 394.59 87.99 395.16 88.68 398.4 89.36 395.16 92.44 394.59 89.38 393.84 88.68 390.77 87.97 393.84 84.91 394.59",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.7 241.8 422.78 242.37 423.46 245.61 424.15 242.37 427.23 241.8 424.17 241.05 423.46 237.98 422.76 241.05 419.7 241.8",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.83 346.69 292.91 347.26 293.6 350.51 294.29 347.26 297.37 346.69 294.3 345.94 293.6 342.88 292.9 345.94 289.83 346.69",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.79 86.07 180.87 86.64 181.56 89.88 182.25 86.64 185.32 86.07 182.26 85.32 181.56 82.25 180.86 85.32 177.79 86.07",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.32 334.9 301.4 335.47 302.09 338.72 302.78 335.47 305.86 334.9 302.79 334.15 302.09 331.08 301.39 334.15 298.32 334.9",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.18,436.2a.9.9,0,0,1,0,1.79A.9.9,0,0,1,198.18,436.2Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.39,268.81a.9.9,0,0,1,0,1.79A.9.9,0,0,1,357.39,268.81Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.24,344a.89.89,0,0,1,0,1.78A.89.89,0,0,1,281.24,344Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.87,429.51a.89.89,0,0,1,0,1.78A.89.89,0,0,1,148.87,429.51Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.81,441.33a.9.9,0,0,1,0,1.79A.9.9,0,0,1,446.81,441.33Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.86,280.51a.89.89,0,0,1,0,1.78A.89.89,0,0,1,399.86,280.51Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.54,420.15a.63.63,0,0,1,0,1.26A.63.63,0,0,1,220.54,420.15Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.46,92.32a.64.64,0,0,1,0,1.27A.64.64,0,0,1,94.46,92.32Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,295.25a.63.63,0,0,1,0,1.26A.63.63,0,0,1,338,295.25Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.46,349.88a.63.63,0,0,1,0,1.26A.63.63,0,0,1,307.46,349.88Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.51,339.23a.64.64,0,0,1,0,1.27A.64.64,0,0,1,257.51,339.23Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.56,283.78a1.71,1.71,0,0,1,0,3.42A1.71,1.71,0,0,1,316.56,283.78Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.99 110.97 234.5 111.99 235.73 117.79 236.96 111.99 242.47 110.97 236.98 109.63 235.73 104.14 234.47 109.63 228.99 110.97",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.98 60.7 253.06 61.27 253.75 64.51 254.44 61.27 257.51 60.7 254.45 59.95 253.75 56.88 253.05 59.95 249.98 60.7",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.34,144a.89.89,0,0,1,0,1.78A.89.89,0,0,1,63.34,144Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.36,380.7a.9.9,0,0,1,0,1.79A.9.9,0,0,1,77.36,380.7Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.19,425a.9.9,0,0,1,0,1.79A.9.9,0,0,1,53.19,425Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9,218.82a.9.9,0,0,1,0,1.79A.9.9,0,0,1,98.9,218.82Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.19,64.77a.9.9,0,0,1,0,1.79A.9.9,0,0,1,53.19,64.77Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.21,338.15a.64.64,0,0,1,0,1.27A.64.64,0,0,1,134.21,338.15Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.39,419.08a.63.63,0,0,1,0,1.26A.63.63,0,0,1,267.39,419.08Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.15,130.23a.64.64,0,0,1,0,1.27A.64.64,0,0,1,361.15,130.23Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.1,91.57a.63.63,0,0,1,0,1.26A.63.63,0,0,1,247.1,91.57Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.23,315.72a1.71,1.71,0,0,1,0,3.42A1.71,1.71,0,0,1,209.23,315.72Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.59,186.45a1.72,1.72,0,0,1,0,3.43A1.72,1.72,0,0,1,434.59,186.45Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.47,336.44a1.71,1.71,0,0,1,0,3.42A1.71,1.71,0,0,1,84.47,336.44Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.19 270.6 231.27 271.17 231.96 274.41 232.65 271.17 235.73 270.6 232.66 269.85 231.96 266.78 231.26 269.85 228.19 270.6",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.6 425.87 296.68 426.44 297.37 429.68 298.05 426.44 301.13 425.86 298.07 425.12 297.37 422.05 296.66 425.12 293.6 425.87",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.24,385.88a.9.9,0,0,1,0,1.79A.9.9,0,0,1,307.24,385.88Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,362.14a.9.9,0,0,1,0,1.79A.9.9,0,0,1,342,362.14Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.96 403.13 235.04 403.7 235.73 406.95 236.42 403.7 239.5 403.13 236.43 402.38 235.73 399.31 235.03 402.38 231.96 403.13",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.7,115.68a.9.9,0,0,1,0,1.79A.9.9,0,0,1,358.7,115.68Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.17,365a.63.63,0,0,1,0,1.26A.63.63,0,0,1,380.17,365Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.52 257.62 114.6 258.19 115.28 261.43 115.97 258.19 119.05 257.62 115.99 256.87 115.28 253.8 114.58 256.87 111.52 257.62",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.92,306.73a.89.89,0,0,1,0,1.78A.89.89,0,0,1,75.92,306.73Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,241a.89.89,0,0,1,0,1.78A.89.89,0,0,1,199,241Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.46,150.83a.64.64,0,0,1,0,1.27A.64.64,0,0,1,94.46,150.83Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.37,145a1.71,1.71,0,0,1,0,3.42A1.71,1.71,0,0,1,86.37,145Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.24,69.49a1.71,1.71,0,0,1,0,3.42A1.71,1.71,0,0,1,436.24,69.49Z",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Planets--inject-49"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 370.95,
    cy: 390.79,
    r: 32.59,
    transform: "translate(-167.05 361.14) rotate(-43.34)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.62,402.75a38.32,38.32,0,0,1,9.63-7.14c6.21-3.36,23.47-7.87,31.25-12.62,10.94-6.67,11.86-13,11.54-16.18a32.77,32.77,0,0,0-10.62-6.52c-.55,3.35-2.78,13.84-21.17,22-9.5,4.23-19,2.68-22.28,2.16A32.48,32.48,0,0,0,340.62,402.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.31,419.39A32.65,32.65,0,0,0,395.7,412a26,26,0,0,0-6-1.85c-8.91-1.42-18.19,3.54-21.54,5.79A19.14,19.14,0,0,1,355.31,419.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.94,407.47l.47.76.44.67c.34.51.68,1,1,1.49s.67.86,1,1.27l.39.46.45.51c.15.17.3.34.46.5l.56.58.56.56.5.47c.37.34.75.67,1.13,1h0c2.07.45,4.76,0,8.59-1.92,5.72-2.79,11.63-8.87,22.7-13.89A40.73,40.73,0,0,1,403,396.77h0a32.5,32.5,0,0,0-2.42-19.57c-2.08.09-8.69,1.58-22,14.48a85,85,0,0,1-13.55,11c-11.65,7.35-18.84,6-21.89,4.79h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.49,372c.7,1.27,2.76,1.48,4.61.47s2.77-2.87,2.08-4.14-2.76-1.47-4.61-.46S371.8,370.68,372.49,372Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.89,373.43c.39.71,1.61.8,2.72.19s1.68-1.68,1.29-2.39-1.61-.81-2.72-.2S381.5,372.71,381.89,373.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.35,415.58c.6,1.09,2.39,1.25,4,.36s2.44-2.48,1.85-3.57-2.39-1.24-4-.36S359.76,414.5,360.35,415.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.43,416.16a1.63,1.63,0,1,0,.81-1.8A1.43,1.43,0,0,0,366.43,416.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.12,413.06a.9.9,0,0,0,1.22.15c.49-.27.73-.77.54-1.11a.91.91,0,0,0-1.23-.15C367.17,412.22,366.93,412.72,367.12,413.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.37,411.13c.53,1,2,1.18,3.3.47s1.91-2.07,1.38-3-2-1.18-3.3-.47S386.84,410.16,387.37,411.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.18,406.78a1.29,1.29,0,1,0,.58-1.62A1.22,1.22,0,0,0,386.18,406.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.89,410.39a281.6,281.6,0,0,0,58.65-19.34c14.6-6.86,23.61-13.43,22.39-17.14s-12.17-3.76-27.6-.79c.42.65.81,1.31,1.19,2,.14.26.27.52.41.77,8.21-1.05,13.65-.57,14.39,1.69s-3.48,6-10.93,10.08A180.49,180.49,0,0,1,374,399.92a180.8,180.8,0,0,1-31,7.55c-8.39,1.11-14,.64-14.72-1.65s3.35-5.85,10.54-9.86a30.54,30.54,0,0,1-.36-3.3C323.88,399.5,314.74,406.3,316,410S328.67,413.66,344.89,410.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.73,412.62a288.17,288.17,0,0,0,28.83-7.76h0a289.24,289.24,0,0,0,27.78-10.49c20.28-9,33.23-18.17,31.54-23.43s-17.28-5.15-38.64-.7c.31.39.62.79.92,1.2,17.94-3.44,30.8-3.25,32.25,1.26s-9.07,12.34-25.94,20.12a261.41,261.41,0,0,1-28.29,10.9,260.13,260.13,0,0,1-29.47,7.72c-18.15,3.52-31.19,3.35-32.65-1.2s8.8-12.13,25.28-19.8c0-.51,0-1,.06-1.53-19.86,8.85-32.48,17.9-30.81,23.1S325.12,417.16,346.73,412.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.75,
    cy: 219.34,
    r: 19.23,
    transform: "translate(-58.55 86.01) rotate(-18.85)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.16,224.93a22.62,22.62,0,0,0-6-3.74c-3.81-1.68-14.18-3.52-19-5.95-6.75-3.4-7.59-7.07-7.55-9a19.19,19.19,0,0,1,5.93-4.34c.48,1.94,2.29,8,13.5,12,5.79,2,11.33.68,13.21.22A19.13,19.13,0,0,1,248.16,224.93Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.31,235.42A19.24,19.24,0,0,1,216.2,233a15.11,15.11,0,0,1,3.45-1.37c5.17-1.26,10.86,1.21,12.94,2.38A11.3,11.3,0,0,0,240.31,235.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,227.82l-.24.46c-.07.15-.15.28-.23.42q-.26.48-.54.93c-.17.27-.35.53-.53.79l-.21.29L245,231l-.25.32q-.14.18-.3.36t-.3.36l-.28.3c-.2.22-.4.43-.61.64h0c-1.19.37-2.8.21-5.14-.72-3.5-1.37-7.26-4.67-14-7.09a24.05,24.05,0,0,0-12.94-.83h0a19.14,19.14,0,0,1,.5-11.62c1.22-.05,5.18.51,13.6,7.47a50.7,50.7,0,0,0,8.49,5.81c7.21,3.77,11.37,2.65,13.11,1.78H247Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.74,235.05c.34-.78,1.54-1,2.68-.51s1.78,1.53,1.44,2.31-1.54,1-2.68.52S228.4,235.84,228.74,235.05Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.18,233.68c.19-.44.9-.55,1.59-.25s1.08.89.89,1.33-.91.56-1.59.26S234,234.13,234.18,233.68Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.27,210.06c.29-.66,1.33-.86,2.33-.42s1.57,1.33,1.27,2-1.33.86-2.33.42S219,210.73,219.27,210.06Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.81,209.4a.83.83,0,0,1,1.13-.27.84.84,0,0,1,.57,1,1,1,0,0,1-1.7-.74Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.38,211.18a.53.53,0,0,1,.71-.15c.3.13.46.41.37.62a.52.52,0,0,1-.71.16A.53.53,0,0,1,223.38,211.18Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.38,211.23a1.64,1.64,0,1,1,1,1.71A1.42,1.42,0,0,1,235.38,211.23Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.92,213.85a.76.76,0,0,1,1.39.61.76.76,0,0,1-1.39-.61Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.75,
    cy: 85.63,
    r: 19.23,
    transform: "translate(-25.04 41.35) rotate(-21.82)",
    style: {
      fill: "#8815E5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.75,
    cy: 85.63,
    r: 19.23,
    transform: "translate(-25.04 41.35) rotate(-21.82)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.16,91.22a22.73,22.73,0,0,0-6-3.74C103.34,85.8,93,84,88.17,81.54c-6.75-3.41-7.59-7.08-7.55-9a19.11,19.11,0,0,1,5.94-4.34c.48,1.94,2.28,8,13.49,12,5.79,2,11.33.67,13.21.21A19.13,19.13,0,0,1,113.16,91.22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.3,101.71a19.26,19.26,0,0,1-24.11-2.43,15.3,15.3,0,0,1,3.45-1.37c5.17-1.26,10.87,1.22,13,2.38A11.27,11.27,0,0,0,105.3,101.71Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112,94.11a5.21,5.21,0,0,1-.24.47c-.07.14-.14.28-.22.42-.18.31-.36.62-.55.92s-.34.54-.53.8l-.21.28a3.81,3.81,0,0,1-.24.32l-.24.32-.3.37-.31.35-.27.31c-.2.22-.41.43-.62.63h0c-1.2.36-2.8.2-5.15-.72-3.49-1.37-7.26-4.67-14-7.1a24.12,24.12,0,0,0-12.93-.83h0A19.14,19.14,0,0,1,76.68,79c1.23-.05,5.18.51,13.61,7.47a49.32,49.32,0,0,0,8.49,5.81C106,96.1,110.15,95,111.89,94.1H112Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.73,101.35c.34-.79,1.54-1,2.68-.52s1.79,1.53,1.45,2.31-1.55,1-2.68.52S93.39,102.13,93.73,101.35Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.18,100c.19-.44.9-.56,1.58-.26s1.08.9.89,1.34-.9.55-1.59.26S99,100.42,99.18,100Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.26,76.36c.29-.67,1.33-.86,2.33-.43s1.57,1.33,1.28,2-1.34.86-2.34.42S84,77,84.26,76.36Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8,75.69a.84.84,0,0,1,1.13-.27.73.73,0,1,1-.56,1.29A.85.85,0,0,1,87.8,75.69Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88.37,77.48a.53.53,0,0,1,.71-.16c.3.14.47.41.38.63a.54.54,0,0,1-.71.15C88.45,78,88.28,77.69,88.37,77.48Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.38,77.52a1.63,1.63,0,1,1,1,1.72A1.42,1.42,0,0,1,100.38,77.52Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99.91,80.14a.76.76,0,0,1,1.39.61.76.76,0,0,1-1.39-.61Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rocket--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.64,122.84c-.71-.85-41.85-19.93-79.11,8.5-34.25,26.14-46.14,75.27-41.59,76.45,5.57,1.44,20.83-22,50.12-34.89,10.39-4.57,26.92,0,26.92,0Z",
    style: {
      fill: "#8815E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,172.89a65.08,65.08,0,0,0-15-2c6.46-13.52,18.52-38.74,26.35-55.08,18.43.17,31.93,6.56,32.34,7Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.41,202.77c.72.84,12.82,44.55-21.33,76.65-31.39,29.52-81.8,33.21-82.22,28.53-.51-5.73,25.12-16.95,42.62-43.74,6.2-9.5,4.41-26.56,4.41-26.56Z",
    style: {
      fill: "#8815E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,236.05l-58.66,17.07a65.15,65.15,0,0,0,.51-15.47l56.52-34.88C301.82,203.25,306,217.74,303,236.05Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.63,256.2l-40.18-47.39s21-56.19,70.76-93.93c24.87-18.83,54-32.92,80.17-42.24C352.43,59.72,382.59,56,387.26,61.48s-4,34.66-22.58,68.13c-13.49,24.21-32.17,50.69-54.81,72.15C264.49,244.72,205.63,256.2,205.63,256.2Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.24,181.47A35.83,35.83,0,1,1,307.4,131,35.84,35.84,0,0,1,303.24,181.47Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.2,178.14a35.83,35.83,0,1,1,4.16-50.5A35.84,35.84,0,0,1,305.2,178.14Z",
    style: {
      fill: "#8815E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.11,169.75a24.85,24.85,0,1,1,2.86-35A24.85,24.85,0,0,1,298.11,169.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.12,169.75a24.83,24.83,0,0,1-7.95,4.55l-20-1.63a24.68,24.68,0,0,1-7.1-5.78,24.36,24.36,0,0,1-3.61-5.65l43.1,3.51A24.49,24.49,0,0,1,298.12,169.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.12,137.68l-39.78-3.24a24.29,24.29,0,0,1,2.6-2.57,24.84,24.84,0,0,1,35,2.86A24.11,24.11,0,0,1,303.12,137.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.28,159.6l-47.6-3.89a20,20,0,0,1-.35-2.21l48.64,4C305.78,158.18,305.54,158.89,305.28,159.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.68,129.61l-48.3-57C352.43,59.72,382.59,56,387.26,61.48S383.3,96.14,364.68,129.61Z",
    style: {
      fill: "#8815E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.58,77.45a2.09,2.09,0,1,1,.24-2.94A2.09,2.09,0,0,1,330.58,77.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.17,87.59a2.09,2.09,0,1,1-2.7-3.19,2.09,2.09,0,0,1,2.7,3.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.76,97.72a2.09,2.09,0,1,1,.25-3A2.08,2.08,0,0,1,347.76,97.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.36,107.86a2.09,2.09,0,1,1,.24-3A2.09,2.09,0,0,1,356.36,107.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,118a2.09,2.09,0,1,1,.24-2.95A2.09,2.09,0,0,1,365,118Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,207.7a2.09,2.09,0,0,1-2.7-3.19,2.09,2.09,0,1,1,2.7,3.19Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.64,217.84a2.09,2.09,0,1,1,.24-3A2.09,2.09,0,0,1,185.64,217.84Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.23,228a2.09,2.09,0,1,1,.24-2.95A2.09,2.09,0,0,1,194.23,228Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.82,238.11a2.09,2.09,0,1,1,.24-3A2.09,2.09,0,0,1,202.82,238.11Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.41,248.24a2.09,2.09,0,1,1,.25-3A2.08,2.08,0,0,1,211.41,248.24Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,60.07c-27.82,2-76,18.84-126.69,58.6-37.46,29.37-64.79,80.77-77.53,108.22l-15.33-18.08s21-56.19,70.76-93.93c24.87-18.83,54-32.92,80.17-42.24C348.69,61.05,376.26,56.85,385,60.07Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.68 263.92 155.01 225.38 167.72 211.49 203.46 253.65 187.68 263.92",
    style: {
      fill: "#8815E5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.46 253.65 195.77 258.65 162.86 216.8 167.72 211.5 203.46 253.65",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.17 134.76 349.24 133.76 342.22 147.98 342.86 132.14 329.28 125.86 344.36 126.01 351.22 112.64 350.86 127.66 364.17 134.76",
    style: {
      fill: "#fcfcfc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.5 79.61 352.15 79.06 348.23 87.01 348.59 78.15 341 74.64 349.43 74.72 353.26 67.25 353.06 75.65 360.5 79.61",
    style: {
      fill: "#fcfcfc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.98 249.13 284.64 248.57 280.72 256.52 281.07 247.67 273.48 244.16 281.91 244.24 285.75 236.77 285.54 245.17 292.98 249.13",
    style: {
      fill: "#fcfcfc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.46 175.38 136.11 174.82 132.19 182.77 132.55 173.92 124.96 170.41 133.39 170.49 137.22 163.02 137.02 171.41 144.46 175.38",
    style: {
      fill: "#fcfcfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.5,255.32c-15.15,10.21-28.52,23.24-38.28,38.81a104.42,104.42,0,0,0-16.39,52.25,95.75,95.75,0,0,0,3.41,27.88,99.77,99.77,0,0,0,11.56,26.2A114.55,114.55,0,0,0,159.41,423a144.89,144.89,0,0,0,23.72,18,146,146,0,0,1-26-15.31,119.07,119.07,0,0,1-22-21.18,107.34,107.34,0,0,1-23.22-57.64c-1.88-21.31,2.62-43.18,11.94-62.69s23.25-36.84,39.71-51Z",
    style: {
      fill: "#8815E5",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.59 278.55 148.63 279.65 147.3 285.93 145.97 279.65 140.01 278.54 145.95 277.09 147.3 271.16 148.66 277.09 154.59 278.55",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.66 396.18 129.33 396.8 128.59 400.31 127.84 396.8 124.51 396.18 127.83 395.37 128.59 392.06 129.35 395.37 132.66 396.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.87 365.71 127.54 366.32 126.8 369.84 126.06 366.32 122.72 365.71 126.04 364.9 126.8 361.58 127.56 364.9 130.87 365.71",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.19 258.96 146.86 259.58 146.11 263.09 145.37 259.58 142.04 258.96 145.36 258.15 146.11 254.84 146.87 258.15 150.19 258.96",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.54,403.78a1,1,0,0,0,0,1.93A1,1,0,0,0,140.54,403.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.1,254.26a1,1,0,0,0,0,1.93A1,1,0,0,0,168.1,254.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.12,340.37a1,1,0,0,0,0,1.93A1,1,0,0,0,116.12,340.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.82,398.75a.69.69,0,0,0,0,1.37A.69.69,0,0,0,138.82,398.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.77,306.63a.68.68,0,0,0,0,1.36A.68.68,0,0,0,115.77,306.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.72,376.49a1.86,1.86,0,0,0,0,3.71A1.86,1.86,0,0,0,122.72,376.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.51,300.35a1.85,1.85,0,0,0,0,3.7A1.85,1.85,0,0,0,124.51,300.35Z",
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJp);
export default __webpack_public_path__ + "static/media/jp.39172344a7b37373e68da435a761d1af.svg";
export { ForwardRef as ReactComponent };